import { ReceiptOutlineIcon } from './ReceiptOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 179831B0-F175-4694-9313-3B745C133F96
 * name receipt-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/receipt-outline.svg
 * tags
 * - Banking 
 */
export const ClothOutlineIcon = ReceiptOutlineIcon;
export default ClothOutlineIcon